// Standard libs
import React, { Dispatch, MutableRefObject, SetStateAction, useState } from 'react'
import { Pagination, Col, Card, ButtonGroup, Button, Carousel, Row } from 'react-bootstrap'
import { FaUser, FaAngleDoubleLeft, FaHome, FaCaretSquareLeft, FaCaretSquareRight } from 'react-icons/fa'
import parse from 'html-react-parser'

// imported libs
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box
} from '@chakra-ui/react'
import {
  faArrowPointer,
  faShareNodes,
  faFolderTree,
  faSliders,
  faArrowsUpDown,
  faArrowsLeftRight,
  faDiagramProject
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// OpenSankey libs
import { SankeyModalWelcome } from 'open-sankey/dist/dialogs/SankeyModalWelcome'
import { windowSankey } from 'open-sankey/dist/configmenus/SankeyUtils'
import { dict_hook_ref_setter_show_dialog_componentsType } from 'open-sankey/src/types/Types'

// Local Libs
import { SankeyPlusShortcut } from './import/SankeyPlus'
import { DownloadExempleExcel } from './import/OpenSankey'
import { suiteApplicationContextType, suiteApplicationDataType, suiteElementsSelectedType } from './import/Types'

export const CardsTemplateBuilder = (
  exemple_menu : object,
  dict_variable_elements_selected : suiteElementsSelectedType,
  dict_variable_application_data : suiteApplicationDataType,
  applicationContext : suiteApplicationContextType
) => {
  const { t } = applicationContext
  /* eslint-disable */
  // @ts-ignore
  const image_preview = require.context('./css/image_preview', true)
  // @ts-ignore
  const imageList = image_preview.keys().map(image => {
    let img = image_preview(image)
    const path = window.location.href
    if ( !path.includes('localhost') ) {    
      img = img.replace('static/', 'static/sankeysuite/')
    }
    return img
  })
  // @ts-ignore
  const list_template = require.context('./css/easy_template', true)
  // @ts-ignore
  const list_template_data = list_template.keys().map(image => list_template(image))
  /* eslint-enable */
  return <>
    {(imageList as string[]).map((_,idx ) => {
      const title=_.split('.').splice(0,1).join('')
      return(
        <Col key={idx}>
          <Card>
            <Card.Img 
              className='img-card' variant="top" 
              src={_} 
              style={{'objectFit':'contain','minHeight':'350px','maxHeight':'500px'}} />
            <Card.Body>
              <Card.Title>{title.replaceAll('_',' ')}</Card.Title>
              <Card.Text>

              </Card.Text>
              <ButtonGroup>
                <Button variant='primary'
                  onClick={() => {
                    dict_variable_elements_selected.multi_selected_nodes.current = []
                    dict_variable_elements_selected.multi_selected_links.current = []
                    dict_variable_elements_selected.multi_selected_label.current = []
                    //const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                    // UploadExemple(
                    //   list_template_data[idx], applicationContext.url_prefix,
                    //   dict_variable_application_data.data,
                    //   dict_variable_application_data.set_data as (d:SankeyData)=>void,
                    //   Reinitialization,convert_data ,dict_variable_application_data.get_default_data
                    // )
                    dict_variable_application_data.set_data(
                      {...list_template_data[idx]})
                  }}>{t('useTemplate')}</Button>

                <Button variant='info'
                  onClick={() => {
                    dict_variable_elements_selected.multi_selected_nodes.current = []
                    dict_variable_elements_selected.multi_selected_links.current = []
                    dict_variable_elements_selected.multi_selected_label.current = []
                    //const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                    DownloadExempleExcel(
                      list_template_data[idx]
                    )
                  }}>{t('dl')}</Button>
              </ButtonGroup>
            </Card.Body>
          </Card>
        </Col>
      )}
    )}
  </>
}

export const welcomeModalBuilder = (
  applicationContext : suiteApplicationContextType,
  dict_variable_application_data : suiteApplicationDataType,
  exemple_menu : object,
  dict_hook_ref_setter_show_dialog_components : dict_hook_ref_setter_show_dialog_componentsType,
  never_see_again : MutableRefObject<boolean>,
  ref_setter_active_page : MutableRefObject<Dispatch<SetStateAction<string>>>
)=>{
  const { t } = applicationContext
  const [active_page,set_active_page] = useState((windowSankey.sankey && windowSankey.sankey.welcome_text)?'read_me':'intro')
  ref_setter_active_page.current = set_active_page

  //const tmp=JSON.parse(JSON.stringify(exemple_menu))
  const additional_shortcut_item=[] as JSX.Element[]
  additional_shortcut_item.push(SankeyPlusShortcut(t))
  /* eslint-disable */
    // @ts-ignore
  const carousel = require.context('./css/image_carousel', true)
  // @ts-ignore
  const imageList = carousel.keys().map(image => {
    let carousel_element = carousel(image)
    const path = window.location.href
    if ( !path.includes('localhost') ) {
      carousel_element = carousel_element.replace('static/', 'static/sankeysuite/')
    }
    return carousel_element
  })
  /* eslint-enable */
  const content_carousel=<Carousel variant='dark'> {
    (imageList as string[]).map((_) => {
      const title=_.split('.').splice(0,1).join('')
      return (<Carousel.Item>
        <img alt={title} src={_}   style={{'objectFit':'contain','width':'100%','height':'650px',display:'inline-block'}}   />
      </Carousel.Item>)
    })
  }
  </Carousel>

  const style_border='solid 1px grey'
  const src_intro_static = 'intro_static.png'

  // Content for welcome modal : Introduction
  const pagination_intro = <Pagination.Item active={active_page==='intro'} key={'intro'} onClick={()=>{
    set_active_page('intro')
  }}>
    {t('welcome.intro')}
  </Pagination.Item>

  const intro = <div>
    {windowSankey.SankeyToolsStatic ?<img src={src_intro_static} alt='intro carousel' style={{'objectFit':'contain','width':'100%'}}/>:content_carousel}
    <p>{t('Banner.hlp_1_txt_1')}</p>
    <table style={{'border':style_border,textAlign:'center'}}>
      {!windowSankey.SankeyToolsStatic?
        <>
          <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'danger'}><FaUser/></Button></td><td style={{'border':style_border}}>{t('welcome.9')}</td></tr>
          <tr style={{'border':style_border}}><td style={{'border':style_border}}><ButtonGroup><Button size='sm' variant={'info'}><FontAwesomeIcon icon={faArrowPointer} /></Button><Button size='sm' variant={'secondary'}><FontAwesomeIcon icon={faShareNodes} /></Button></ButtonGroup></td><td style={{'border':style_border}}>{t('welcome.1')}</td></tr>
        </>:
        <></>
      }

      <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'warning'}><FontAwesomeIcon icon={faFolderTree} /></Button></td><td style={{'border':style_border}}>{t('welcome.3')}</td></tr>
      <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'danger'}><FontAwesomeIcon icon={faSliders} /></Button></td><td style={{'border':style_border}}>{t('welcome.4')}</td></tr>
      <tr style={{'border':style_border}}><td style={{'border':style_border}}><ButtonGroup><Button size='sm' variant={'dark'}><FontAwesomeIcon icon={faArrowsUpDown} /></Button><Button size='sm' variant={'dark'}><FontAwesomeIcon icon={faArrowsLeftRight} /></Button></ButtonGroup></td><td style={{'border':style_border}}>{t('welcome.5')}</td></tr>
      <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'success'}><FontAwesomeIcon icon={faDiagramProject} /></Button></td><td style={{'border':style_border}}>{t('welcome.6')}</td></tr>
      <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'success'}><FaAngleDoubleLeft/></Button></td><td style={{'border':style_border}}>{t('welcome.10')}</td></tr>
      {(!windowSankey.SankeyToolsStatic ||
      (windowSankey.SankeyToolsStatic && dict_variable_application_data.data.view.length!==0))?
        <tr style={{'border':style_border}}>
          <td style={{'border':style_border}}>
            <ButtonGroup>
              <Button size='sm' variant={'light'}><FaHome/></Button>
              <Button size='sm' variant={'light'}><FaCaretSquareLeft/></Button>
              <Button size='sm' variant={'light'}><FaCaretSquareRight/></Button>
            </ButtonGroup>
          </td>
          <td>{t('welcome.view')}</td>
        </tr>:
        <></>
      }
      {windowSankey.SankeyToolsStatic && windowSankey.sankey && windowSankey.sankey.excel?
        <tr style={{'border':style_border}}>
          <td style={{'border':style_border}}>
            <Button variant='link'>{t('Banner.tl')}</Button>
          </td>
          <td style={{'border':style_border}}>{t('welcome.excel')}</td>
        </tr>:
        <></>
      }

    </table>
  </div>

  // Content for welcome modal : Licences explanation
  const content_licence = <>
    {/* OpenSankey */}
    <Row>
      <Col xs={3}>
        <img src={applicationContext.logo_OS} alt='logo_OS' style={{'objectFit':'contain','width':'250px'}}/>
      </Col>
      <Col style={{whiteSpace:'pre-line'}}>
        {t('Menu.presentation_OS')}
        <Button href="https://terriflux.com/downloads/open-sankey/" target="_blank" rel="noopener noreferrer">
          {t('desire_to_know_more')}
        </Button>
      </Col>
    </Row>
    <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
    {/* OpenSankey+ */}
    <Row>
      <Col style={{whiteSpace:'pre-line'}}>{t('Menu.presentation_OSP')}
        <Button href="https://terriflux.com/downloads/open-sankey-plus/" target="_blank" rel="noopener noreferrer">
          {t('desire_to_know_more')}
        </Button>
      </Col>
      <Col xs={3}><img src={applicationContext.logo_OSP} alt='logo_OSP' style={{'objectFit':'contain','width':'250px'}}/></Col>
    </Row>
    <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
    {/* SankeySuite */}
    <Row>
      <Col xs={3}><img src={applicationContext.logo_OSS} alt='logo_OSS' style={{'objectFit':'contain','width':'250px'}}/></Col>
      <Col style={{whiteSpace:'pre-line'}}>
        {t('Menu.presentation_OSS')}
        <Button href="https://terriflux.com/downloads/sankey-suite/" target="_blank" rel="noopener noreferrer">
          {t('desire_to_know_more')}
        </Button>
      </Col>
    </Row>
  </>

  /* eslint-disable */
  // @ts-ignore
  // Content for welcome modal : Updates in Sankey app
  let image1 = require('./css/news_material/' + t('welcome.news_content.230803.image1'))
  let image2 = require('./css/news_material/' + t('welcome.news_content.230803.image2'))
  let image3 = require('./css/news_material/' + t('welcome.news_content.230803.image3'))
  let image4 = require('./css/news_material/' + t('welcome.news_content.230803.image4'))
  if ( !windowSankey.location.href.includes('localhost') ) {
    image1 = image1.replace('static/', 'static/sankeysuite/')
    image2 = image2.replace('static/', 'static/sankeysuite/')
    image3 = image3.replace('static/', 'static/sankeysuite/')
    image4 = image4.replace('static/', 'static/sankeysuite/')
  }

  let image_230908_1 = require('./css/news_material/' + t('welcome.news_content.230908.img1'))
  const image_230908_2 = require('./css/news_material/' + t('welcome.news_content.230908.img2'))
  let image_230908_3 = require('./css/news_material/' + t('welcome.news_content.230908.img3'))
  /* eslint-enable */
  if ( !windowSankey.location.href.includes('localhost') ) {
    image_230908_1 = image_230908_1.replace('static/', 'static/sankeysuite/')
    image_230908_1 = image_230908_2.replace('static/', 'static/sankeysuite/')
    image_230908_3 = image_230908_2.replace('static/', 'static/sankeysuite/')

  }
  const content_news=<>
    <Accordion
      allowToggle
      // className='accordion_new_welcome'
      // defaultActiveKey={'08-09-23'}
    >
      {/* New 08 Septembre 2023 */}
      <AccordionItem
        // eventKey='08-09-23'
      >
        <AccordionButton>
          <Box as='span' width='100%'>
            <Box
              layerStyle='menuconfig_entry'
            >
              {t('welcome.news_content.230908.main_title')}
            </Box>
            <Box
              layerStyle='submenuconfig_entry'
            >
              {t('welcome.news_content.230908.main_content')}
            </Box>
          </Box>
          <AccordionIcon/>
        </AccordionButton>
        <AccordionPanel>
          <h3>{t('welcome.news_content.230908.sub_title_1')}</h3>
          <p>{t('welcome.news_content.230908.sub_content_1')}</p>
          <Row >
            <Col xs={6}><img src={image_230908_1} alt='menu_config_node' style={{'objectFit':'contain','height':'450px'}}/></Col>
            <Col xs={6}><img src={image_230908_2} alt='menu config zdd' style={{'objectFit':'contain','height':'350px'}}/></Col>
          </Row>

          <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
          <h3>{t('welcome.news_content.230908.sub_title_2')}</h3>
          <p>{t('welcome.news_content.230908.sub_content_2')}</p>
          <Row >
            <img src={image_230908_3} alt='menu_config_node' style={{'objectFit':'contain','width':'450px'}}/>
          </Row>
          <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        </AccordionPanel>
      </AccordionItem>


      {/* New 03 Août 2023 */}
      <AccordionItem
      // eventKey='03-09-23'
      >
        <AccordionButton>
          <Box as='span' width='100%'>
            <Box
              layerStyle='menuconfig_entry'
            >
              {t('welcome.news_content.230803.main_title')}
            </Box>
            <Box
              layerStyle='submenuconfig_entry'
            >
              {t('welcome.news_content.230803.main_content')}
            </Box>
          </Box>
          <AccordionIcon/>
        </AccordionButton>
        <AccordionPanel>
          <Row>
            <h3>{t('welcome.news_content.230803.sub_title_1')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_1')}</p>
            <Col xs={3}><img src={image1} alt='Right clic nodes' style={{'objectFit':'contain','height':'250px'}}/></Col>
            <Col xs={3}><img src={image2} alt='Right clic links' style={{'objectFit':'contain','height':'250px'}}/></Col>
            <Col xs={6}><img src={image3} alt='Right clic background' style={{'objectFit':'contain','height':'250px'}}/></Col>
          </Row>
          <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
          <Row>
            <h3>{t('welcome.news_content.230803.sub_title_2')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_2')}</p>
            <Col xs={3}><img src={image4} alt='Selection zone' style={{'objectFit':'contain','height':'250px'}}/></Col>
          </Row>
          <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
          <Row>
            <h3>{t('welcome.news_content.230803.sub_title_3')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_3')}</p>
          </Row>
        </AccordionPanel>
      </AccordionItem>

    </Accordion>

    {/* <Row>
            <h2>{t('welcome.news_content.230803.main_title')}</h2>
            <p><b>{t('welcome.news_content.230803.main_content')}</b></p>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        <Row>
            <h3>{t('welcome.news_content.230803.sub_title_1')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_1')}</p>
            <Col xs={3}><img src={image1} alt='Right clic nodes' style={{'objectFit':'contain','height':'250px'}}/></Col>
            <Col xs={3}><img src={image2} alt='Right clic links' style={{'objectFit':'contain','height':'250px'}}/></Col>
            <Col xs={6}><img src={image3} alt='Right clic background' style={{'objectFit':'contain','height':'250px'}}/></Col>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        <Row>
            <h3>{t('welcome.news_content.230803.sub_title_2')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_2')}</p>
            <Col xs={3}><img src={image4} alt='Selection zone' style={{'objectFit':'contain','height':'250px'}}/></Col>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        <Row>
            <h3>{t('welcome.news_content.230803.sub_title_3')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_3')}</p>
        </Row> */}
  </>

  const pagination_read_me = (windowSankey.sankey && windowSankey.sankey.welcome_text)?
    <Pagination.Item active={active_page==='read_me'} key={'read_me'} onClick={()=>{
      set_active_page('read_me')}}>{t('welcome.read_me')}
    </Pagination.Item>:
    <></>

  const pagination_rc = windowSankey.SankeyToolsStatic?
    <></>:
    <Pagination.Item active={active_page==='licence'} key={'licence'} onClick={()=>{
      set_active_page('licence')
    }}>
      {t('welcome.licence')}
    </Pagination.Item>

  const pagination_news=(!windowSankey.SankeyToolsStatic)?<Pagination.Item active={active_page==='news'} key={'news'} onClick={()=>{
    set_active_page('news')
  }}>
    {t('welcome.news')}
  </Pagination.Item>:<></>

  const external_pagination=[
    pagination_read_me,
    pagination_intro,
    pagination_rc,
    pagination_news]

  const external_content={
    'read_me': windowSankey.sankey && windowSankey.sankey.welcome_text ?parse(windowSankey.sankey.welcome_text) :'',
    'intro':intro,
    'rc':<></>,
    'licence':content_licence,
    'news':content_news}

  return SankeyModalWelcome(
    t,
    active_page,
    set_active_page,
    dict_hook_ref_setter_show_dialog_components,
    never_see_again,
    additional_shortcut_item,
    external_pagination,
    external_content,
    exemple_menu
  )
}
